<template>
    <div class="BaseLoader">
        <div class="BaseLoader_content">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseLoader'
    };
</script>

<style>
    /*BaseLoader component css is located in index.html as it's used prior Vue is loaded*/
</style>



// WEBPACK FOOTER //
// BaseLoader.vue?69d27a92